module.exports = __webpack_public_path__ + "img/bottomLogo.3447ba0d.png";